import request from '@/utils/request'

const activityTypeURL = {
  List: 'platform-activity-category/list',
  Created: 'platform-activity-category/create',
  Update: 'platform-activity-category/update',
  Delete: 'platform-activity-category/delete'
}

// 获奖列表 & 详情(参数传id = *)
export function fetchActivityTypeList (params) {
  return request({
    url: activityTypeURL.List,
    method: 'post',
    params
  })
}

// 新增
export function createdActivityType (data) {
  return request({
    url: activityTypeURL.Created,
    method: 'post',
    data
  })
}

// 修改
export function updateActivityType (data) {
  return request({
    url: activityTypeURL.Update,
    method: 'post',
    data
  })
}

// 删除
export function deleteActivityType (data) {
  return request({
    url: activityTypeURL.Delete,
    method: 'post',
    data
  })
}

export default {
  fetchActivityTypeList,
  createdActivityType,
  updateActivityType,
  deleteActivityType
}
